/**
 * Склонение
 * @param {Number} value — часы
 */
const convertHoursToDays = (numberOfHours) => {
  return Math.floor(numberOfHours / 24);
};

export default convertHoursToDays;
